import onReady from '../utils/onReady';
import Flatpickr from '../vendor/flatpickr';
import Flatpickrl10n from 'flatpickr/dist/l10n/da';


/**
 *
 * @param {HTMLElement} container
 * @constructor
 */
class DatePicker {

    /**
     * The constructor is fired once the class is instantiated.
     *
     * @param {HTMLElement} container
     */
    constructor(container) {
        // Run initializing code once the DOM is ready.
        onReady(() => this.init(container));
    }


    /**
     * The actual initialization function, fired once the DOM is ready.
     *
     * @param {HTMLElement} container
     */
    init(container) {

        this.dom = {
            container // ES6 allows this syntax instead of writing "container: container"
        };

        this.todayFlag = this.dom.container.dataset.todaysDate;

        // Put your other DOM-specific initializations here, and get your class moving!

        let date = new Date(),
            dateTwentyYearsAgo = date.getFullYear() - 20;

        let datePickerOptions = {
            altInput: true,
            dateFormat: "d-m-Y",
            altFormat: "d-m-Y",
            // defaultDate: "01-01-" + dateTwentyYearsAgo,
            maxDate: "today",
            allowInput: true,
            onChange: function(selectedDates, dateStr) {
                //jshint unused:false
                this._selectedDateStr = dateStr;
            },
            onClose: function() {
                if (this.config.allowInput && this._input.value && this._input.value !== this._selectedDateStr) {
                    this.setDate(this._input.value, false);
                }
            }
        };

        Flatpickr.localize(Flatpickrl10n.da);
        let calendar = new Flatpickr(this.dom.container, datePickerOptions);

        if (!this.todayFlag) {
            calendar.jumpToDate("01-01-" + dateTwentyYearsAgo);
        }

    }

}


export default DatePicker;